import Request from '@yichui/js-contrib/src/request';

// 覆盖单机数据存储方式
Request.hookGetValue(key => {
  return uni.getStorageSync(key);
});
Request.hookSetValue((key, val) => {
  return uni.setStorageSync(key, val);
});
Request.hookDelValue(key => {
  return uni.removeStorageSync(key);
});

// 覆盖默认错误处理方式
Request.hookErrorHandler(err => {
  const info = Request.getErrorMsg(err);
  if (uni && uni.showModal) {
    uni.showModal({
      title: `错误:${info.title}`,
      content: `${info.message} ${info.code}`,
      showCancel: false,
    });
  } else {
    alert(`${info.message} ${info.code}`);
  }
});

// 覆盖json网络请求方法
Request.hookFetchJson(function (url = '', method = 'POST', headers = {}, data = '') {
  return new Promise((resolve, reject) => {
    uni.request({
      url: url,
      method: method,
      header: headers,
      sslVerify: false,
      data: data,
      complete: res => {
        if (!res || !res.data) {
          reject('undefined');
        } else {
          resolve(res.data);
        }
      },
      fail: err => {
        reject(err);
      },
    });
  });
});

//
export default {
  ...Request,
  //
  request: Request.requestGql,
};
